import React, { useRef, useState } from 'react'
import { BsPlus } from 'react-icons/bs'
import Loader from 'react-loader-spinner'
import '../styles/components/UploadImageWithTextButton.css'

const UploadImageWithTextButton = ({ onClick, loadingButton }) => {
  const fileInputRef = useRef(null)
  const [selectedImage, setSelectedImage] = useState(null)
  const [text, setText] = useState(null)

  const handleChangeText = (e) => {
    setText(e.target.value)
  }

  const handleButtonClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setSelectedImage(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleSendButton = () => {
    onClick({text, image: selectedImage})
  }

  return (
    <div className='upload-container'>
      <div className={'upload-inner-container'} style={{ marginTop: 32 }}>
        <div className='image-button-container' onClick={handleButtonClick}>
          {selectedImage ? (
            <div className='preview-image-container'>
              <img
                src={selectedImage}
                alt='Selected'
                className='preview-image'
              />
            </div>
          ) : (
            <div className='add-image-button-container'>
              <button className='add-image-button'>
                <BsPlus size={70} color='#bdbdbd' />
              </button>
            </div>
          )}
          <input
            type='file'
            accept='image/*'
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
        <textarea
          className='text-area'
          placeholder='Digite algo para a consultora. Ex: Olha este look que eu usei hoje'
          onChange={handleChangeText}
        />
      </div>
      <button
        onClick={handleSendButton}
        className='remeberyou-send-button'
      >
        {loadingButton
          ? <Loader
            type='TailSpin'
            color='white'
            height={17}
            width={17}
          />
          : 'ENVIAR'
        }
      </button>
    </div>
  )
}

export default UploadImageWithTextButton



// WEBPACK FOOTER //
// ./src/components/UploadImageWithTextButton.js